<script>
import AlertDialogItem from './AlertDialogItem.vue'
export default {
  components: { AlertDialogItem },
  props: {
    showAlertDialog: { type: Boolean },
    closeAlertDialog: { type: Function },
    alertList: { type: Object }
  },
  computed: {
    reducedAlertList() {
      return Object.keys(this.alertList).filter(
        listItem => this.alertList[listItem].length
      )} }
}
</script>
<template>
  <v-dialog v-model="showAlertDialog" max-width="500" persistent
  ><v-card>
    <v-card-title class="justify-center subtitle-1">
        <span class="error--text">
          <v-icon color="error">mdi-information</v-icon>&nbsp;{{
            $t('component.upload.alertDialog.title')
          }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="primary--text pb-0">
      <v-list three-line>
        <template v-for="(item, index) in reducedAlertList">
          <v-list-item :key="item">
            <AlertDialogItem :file-list="alertList[item]" :error="item" />
          </v-list-item>
          <v-divider
            v-if="index < reducedAlertList.length - 1"
            :key="index" />
        </template>
      </v-list>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="justify-center">
      <v-btn
        color="primary"
        class="white--text text-capitalize ma-2"
        @click="closeAlertDialog"
      ><span>{{ $t('button.ok') }}</span></v-btn>
    </v-card-actions>
  </v-card>
  </v-dialog>
</template>
